import { createAsyncTypes } from 'utils/ActionCreator'

const containerKey = 'Notifications/EndUser/Editor'

export const DATA_UPDATE_ASYNC = createAsyncTypes('DATA_UPDATE', containerKey)
export const LOCALE_REQUEST_ASYNC = createAsyncTypes('LOCALE_REQUEST', containerKey)
export const RECIPIENTS_REQUEST_ASYNC = createAsyncTypes('RECIPIENTS_REQUEST', containerKey)
export const RECIPIENTS_COUNT_REQUEST_ASYNC = createAsyncTypes(
  'RECIPIENTS_COUNT_REQUEST',
  containerKey
)

export const ANNOUNCEMENT_UPDATE = `${containerKey}/ANNOUNCEMENT_UPDATE`
export const CHANGE_RECIPIENTS_SEARCH_FILTER = `${containerKey}/CHANGE_RECIPIENTS_SEARCH_FILTER`

export const RECIPIENTS_KEY = {
  SELECTED: 'selected',
  EXCLUDED: 'excluded',
}
